import { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import {IoArrowBack} from "react-icons/io5";
import Header from "./Header";
import Card from "../components/Card";
import PriceSelector from "../components/PriceSelector";
import _map from 'lodash/map';
import _each from 'lodash/each';
import request from 'request';

class Step3 extends Component {

  constructor(props) {
    super(props);
    this.doExport = this.doExport.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  doExport() {
    const productIndex = {
      20: 0,
      60: 1,
      100: 2,
      200: 3
    }
    const product = window.tProjectGlobals.initialStates.products[productIndex[this.props.amount]]
    const layout = this.props.layouts[this.props.currentLayout];

    request.post(window.tProjectGlobals.baseUrl + '/designer/submit2', {
      body: {
        files: {
          file: this.props.previewUrl
        }
      },
      json: true
    }, (err, res, json) => {
      //const json = JSON.parse(body);
      const surfaces = [];

      surfaces.push({
        id: product.surfaces[1].id,
        data: {
          objects: layout.objects,
          values: this.props.values,
          fontSizes: this.props.fontSizes
        },
        image: json.url,
        imageBackup: this.props.backupImage
      })

      const payload = {
        meishi: true,
        amount: this.props.amount,
        product: product.id,
        color: product.surfaces[1].id,
        surfaces: surfaces,
        // sizes: _map(this.props.products.sizes, (size) => {
        //   return {
        //     id: size.id,
        //     amount: this.props.products.amount[size.id]
        //   }
        // }),
        sizes: [{
          id: product.sizes[0].id,
          amount: 1
        }],
        user: window.tProjectGlobals.userId,
        coupon: null,
        mobile: true,
        backupImage: this.props.backupImage
      };

      //console.log(payload);

      // Fixme: This URL should be optional
      request.post(window.tProjectGlobals.baseUrl + '/designer/checkout', {
        json: payload
      }, (err, res, json) => {
        //console.log(json);

        if (json) {
          // Fixme: This URL should be optional
          window.location.href = window.tProjectGlobals.baseUrl + '/checkout';
        }
      })
    })
  }

  handleSubmit() {
    this.doExport();
  }

  render() {
    const layout = this.props.layouts[this.props.currentLayout];

    let width = 180;

    if (window.innerWidth <= 375) {
      width = 150;
    }

    return (
      <div className="t-mobile-container">
        <Header />
        <div className="t-main">
          <div className="t-alert">
            <span className="t-secondary-title">STEP3</span> 最終確認・数量選択
          </div>

          <div className="t-confirm-flex">
            <div className="t-confirm-flex-item">
              {/*<div className="t-confirm-title"><span className="t-confirm-title-label">パターン</span></div>*/}
              {/*<div className="t-confirm-card text-center mb-3">*/}
              {/*  {layout.name}*/}
              {/*</div>*/}
              <div className="t-confirm-title"><span className="t-confirm-title-label">顔写真</span></div>
              <div className="t-confirm-card square">
                <div className="t-square-image" style={{backgroundImage: 'url(' + this.props.previewUrl + ')'}}/>
                {/*<img className="user-image" src={this.props.previewUrl} alt=""/>*/}
              </div>
            </div>
            <div className="t-confirm-flex-item">
              <div className="t-confirm-title"><span className="t-confirm-title-label">仕上がりイメージ</span></div>
              <div className="t-confirm-card">
                <Card
                  objects={layout.objects}
                  values={this.props.values}
                  fontSizes={this.props.fontSizes}
                  width={width}
                  showPlaceholder={false}
                  sample={false}
                />
              </div>

            </div>
          </div>

          <PriceSelector value={this.props.amount} />
        </div>
        <div className="t-footer">
          <div className="t-footer-actions">
            <Link to={`${process.env.PUBLIC_URL}/step2`} className="btn btn-secondary btn-icon"><IoArrowBack /></Link>
            <button className="btn btn-primary" onClick={this.handleSubmit}>お支払いへ進む</button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {})(Step3);